import React, {ReactElement, ReactNode} from 'react';
import styled from 'styled-components';

interface GridProps {
    dimension: string;
    parts: number;
    children: ReactNode;
}

const StyledGrid = styled.div<{dimension : string, parts : number}>`
    display:grid;
    grid-gap: 1rem;
    grid-template-columns: repeat(${(props) => props.parts}, 1fr);
    grid-template-areas: ${(props) => props.dimension};
    align-content:center;
    align-items:start;
    background: transparent;
`;

const Grid = ({dimension, parts, children } : GridProps) : ReactElement => {
    return (<StyledGrid parts={parts} dimension={dimension}>{children}</StyledGrid>)
}

const StyledGridElement = styled.div<{position : string}>`
    align-self: center;
    grid-area: ${(props) => props.position};
`;


interface GridElementProps {
    position: string;
    children: ReactNode;
}

const GridElement = ({position,children } : GridElementProps) : ReactElement => {
    return (<StyledGridElement position={position}>{children}</StyledGridElement>)
}

export {Grid, GridElement}